import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {TranslationSettingComponent} from './components/dialogs/translation-setting/translation-setting.component';
import {TranslationDownloadDialogComponent} from "./components/dialogs/translation-download-dialog/translation-download-dialog.component";
import {TranslationComponent} from "./components/translation/translation.component";
import {TranslationDownloadActionCellViewerComponent} from "./components/translation-download-action-cell-viewer/translation-download-action-cell-viewer.component";
import {ActionButtonDialogComponent} from "./components/dialogs/action-button-dialog/action-button-dialog.component"
import {UpdateTranslationSettingComponent} from "./components/dialogs/update-translation-setting/update-translation-setting.component";
import {TranslationCompareDialogComponent} from "./components/dialogs/translation-compare-dialog/translation-compare-dialog.component";
import {TranslationConvertCurrencyDialogComponent} from "./components/dialogs/translation-convert-currency-dialog/translation-convert-currency-dialog.component";
import {TranslationStatusCellViewerComponent} from "./components/cell-viewer/translation-status-cell-viewer/translation-status-cell-viewer.component";
import {SelectTranslationLanguageComponent} from "@features/translation/components/dialogs/select-translation-language-dialog/select-translation-language.component";
// @dynamic
export class TranslationDynamicComponentHelper {
  static components: any;

  static create(): void {
  }

  public static init() {
    if (TranslationDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['TranslationComponent'] = TranslationComponent;
    components['TranslationDownloadDialogComponent'] = TranslationDownloadDialogComponent;
    components['TranslationSettingComponent'] = TranslationSettingComponent;
    components['SelectTranslationLanguageComponent'] = SelectTranslationLanguageComponent;
    components['TranslationDownloadActionCellViewer'] = TranslationDownloadActionCellViewerComponent;
    components['ActionButtonDialogComponent'] = ActionButtonDialogComponent;
    components['UpdateTranslationSettingComponent'] = UpdateTranslationSettingComponent;
    components['TranslationCompareDialogComponent'] = TranslationCompareDialogComponent;
    components['TranslationConvertCurrencyDialogComponent'] = TranslationConvertCurrencyDialogComponent;
    components['TranslationStatusCellViewerComponent'] = TranslationStatusCellViewerComponent;
    TranslationDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    TranslationDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }

  public static getComponentArray(): any[] {
    TranslationDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(TranslationDynamicComponentHelper.components).forEach(key => {
      componentArray.push(TranslationDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
